import { LitElement, html, css } from 'lit'
import { property, customElement } from 'lit/decorators.js'
import { positiveIntegerAttributeSchema } from './helpers/yup'

@customElement('zaptic-spacer')
export class Spacer extends LitElement {
    @property({
        type: Number,
        attribute: 'horizontal-spacing',
        converter: (value) => positiveIntegerAttributeSchema.validateSync(value),
    })
    horizontalSpacing = 0

    @property({
        type: Number,
        attribute: 'vertical-spacing',
        converter: (value) => positiveIntegerAttributeSchema.validateSync(value),
    })
    verticalSpacing = 0

    static styles = css`
        :host {
            display: block;
        }
    `

    render() {
        return html`
            <div
                style="
                width: ${this.horizontalSpacing ?? 0}px;
                height: ${this.verticalSpacing ?? 0}px;
            "
            ></div>
        `
    }
}
